import { BaseModel } from "shared-domains/domains/base.model";

/**
 * Thương hiệu riêng (white-label) của một tenant: logo, favicon và tên hiển thị trên tab.
 *
 * Ba chỗ dùng model này lấy dữ liệu theo hai đường khác nhau:
 * - TRƯỚC đăng nhập: REST ẩn danh `GET /auth/branding`, tenant suy từ hostname.
 * - SAU đăng nhập: gRPC `GetTenantBranding(tenantId)`.
 *
 * URL rỗng nghĩa là "dùng ảnh mặc định của sản phẩm", không phải lỗi.
 */
export class TenantBranding extends BaseModel {
    public TenantBrandingId: number = 0;
    public TenantId: number = 0;
    public BrandTitle: string = "";
    public Slogan: string = "";
    /** Logo ngang (wordmark): sidebar mở rộng + màn đăng nhập. */
    public LogoUrl: string = "";
    /** Logo vuông: sidebar thu gọn + splash. */
    public IconUrl: string = "";
    public FaviconUrl: string = "";
    /** BusinessFileId bên FileMedia, rỗng khi đang dùng ảnh mặc định. */
    public LogoFileId: string = "";
    public IconFileId: string = "";
    public FaviconFileId: string = "";
    /**
     * Màu thương hiệu `#RRGGBB`. Rỗng = bảng màu mặc định của sản phẩm.
     * Đây là màu NỀN; màu chữ luôn do client tính lại để bảo đảm tương phản (xem `brand-theme.ts`).
     */
    public PrimaryColor: string = "";
    /** `eTenantSidebarScheme`: 0 tự động, 1 nền sáng, 2 nền tối. */
    public SidebarScheme: number = 0;
}

/** Đúng những trường mà endpoint ẩn danh `GET /auth/branding` trả về. */
export interface HostBrandingDto {
    tenantId: number;
    brandTitle: string;
    slogan: string;
    logoUrl: string;
    iconUrl: string;
    faviconUrl: string;
    primaryColor: string;
    sidebarScheme: number;
}
